import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { useLang, localName } from "../i18n";
import { GoldButton } from "./motion";

export default function SearchModule() {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const [q, setQ] = useState({ city: "", date: "", guests: "", cuisine_id: "" });
  const { data: cuisines } = useQuery({ queryKey: ["cuisines"], queryFn: () => api.get("/cuisines").then((r) => r.data) });
  const { data: experiences } = useQuery({ queryKey: ["experiences", lang], queryFn: () => api.get(`/experiences?lang=${lang}`).then((r) => r.data) });
  const [exp, setExp] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    Object.entries(q).forEach(([k, v]) => v && params.set(k, v));
    navigate(`/${lang}/chefs?${params.toString()}`);
  };

  const field = "bg-transparent border-0 border-b border-white/20 focus:border-gold px-1 py-3 text-sm text-ivory placeholder:text-neutral-500 focus:outline-none w-full transition-colors";

  return (
    <form onSubmit={submit} data-testid="hero-search-module"
      className="backdrop-blur-xl bg-black/55 border border-white/15 p-6 sm:p-8 grid grid-cols-2 md:grid-cols-6 gap-x-6 gap-y-4 items-end">
      <div>
        <label className="lux-label">{t("search.location")}</label>
        <input data-testid="search-city-input" className={field} placeholder="Paris" value={q.city} onChange={(e) => setQ({ ...q, city: e.target.value })} />
      </div>
      <div>
        <label className="lux-label">{t("search.date")}</label>
        <input data-testid="search-date-input" type="date" className={field} value={q.date} onChange={(e) => setQ({ ...q, date: e.target.value })} />
      </div>
      <div>
        <label className="lux-label">{t("search.guests")}</label>
        <input data-testid="search-guests-input" type="number" min="1" max="50" className={field} placeholder="4" value={q.guests} onChange={(e) => setQ({ ...q, guests: e.target.value })} />
      </div>
      <div>
        <label className="lux-label">{t("search.cuisine")}</label>
        <select data-testid="search-cuisine-select" className={field} value={q.cuisine_id} onChange={(e) => setQ({ ...q, cuisine_id: e.target.value })}>
          <option value="" className="bg-coal">{t("search.any")}</option>
          {cuisines?.map((c) => (
            <option key={c.id} value={c.id} className="bg-coal">{localName(c, lang)}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="lux-label">{t("search.experience")}</label>
        <select data-testid="search-experience-select" className={field} value={exp} onChange={(e) => setExp(e.target.value)}>
          <option value="" className="bg-coal">{t("search.any")}</option>
          {experiences?.map((x) => (
            <option key={x.id} value={x.slug} className="bg-coal">{x.name}</option>
          ))}
        </select>
      </div>
      <GoldButton type="submit" data-testid="search-submit-btn" className="w-full h-[50px]">
        {t("search.cta")}
      </GoldButton>
    </form>
  );
}
